import { render, staticRenderFns } from "./codeMaster.vue?vue&type=template&id=5063327b"
import script from "./codeMaster.vue?vue&type=script&lang=js"
export * from "./codeMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5063327b')) {
      api.createRecord('5063327b', component.options)
    } else {
      api.reload('5063327b', component.options)
    }
    module.hot.accept("./codeMaster.vue?vue&type=template&id=5063327b", function () {
      api.rerender('5063327b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/code/codeMaster.vue"
export default component.exports